import { Card } from "@mui/material";
import SoftBox from "components/SoftComponents/SoftBox";
import SoftTypography from "components/SoftComponents/SoftTypography";
import PropTypes from "prop-types";
import { Link } from "react-router-dom";

function EventsBarPreviewCard({ event }) {

    const eventBoxShadowType = (boxShadows) => {
        if (event.type == 'active') {
            return boxShadows.activeEventBoxShadow;
        }
        else if (event.type == 'warning') {
            return boxShadows.warningEventBoxShadow;
        }

        return boxShadows.upcomingEventBoxShadow;
    };

    return (
        <SoftBox width='100%' height='100%'>
            {/* <Link to={'/explore/event-groups/' + event.groups.map((row) => { return row.group_id }).join(',')} style={{ textDecoration: 'none' }}> */}
                <Card /*onClick={() => onEventClick()}*/ sx={({ boxShadows, breakpoints, functions: { pxToRem } }) => ({ width: 'inherit', height: '100%', boxShadow: eventBoxShadowType(boxShadows) })}>
                    <SoftBox py={2} px={1}
                        sx={{
                            height: '100%',
                            display: 'flex',
                            flexDirection: 'column',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                            textAlign: 'center'
                        }}>
                        {event.type != 'active' ? (
                            <SoftBox py={1}>
                                <SoftTypography variant='h4' textTransform={'capitalize'} fontWeight={'medium'}>
                                    {event.name}
                                </SoftTypography>
                                <SoftTypography variant='subtitle2' textTransform={'capitalize'}>
                                    {event.type != 'warning' ? 'Upcoming' : event.type + ' Period'}
                                </SoftTypography>
                            </SoftBox>
                        ) : (
                            <SoftBox py={1}>
                                <SoftTypography variant='h3' textTransform={'capitalize'} fontWeight={'bold'}>
                                    {event.name}
                                </SoftTypography>
                                <SoftTypography variant='subtitle2' textTransform={'capitalize'}>
                                    Active Period
                                </SoftTypography>
                            </SoftBox>
                        )}
                        <SoftBox py={1}>
                            <SoftTypography variant={event.type != 'active' ? 'h6' : 'h5'}>
                                {event.description}
                            </SoftTypography>
                        </SoftBox>
                    </SoftBox>
                </Card>
            {/* </Link> */}
        </SoftBox>
    );
}

EventsBarPreviewCard.propTypes = {
    event: PropTypes.object,
    deviceLayout: PropTypes.string,
    miniNavbar: PropTypes.bool,
};


export default EventsBarPreviewCard;